module.exports = __webpack_public_path__ + "img/mc-repeat-one.3e2454ad.svg";